<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Alert } from '@Shelly/shelly-design-system/index';
	//Helpers
	import { isSequenceRunning } from 'src/helpers/xt1_helpers/irrigation/irrigation_helpers';
	//Components
	import TemplateInputSettings from '../Components/TemplateInputSettings.svelte';
	import IrrigationConfirmModal from './IrrigationConfirmModal.svelte';
	//Types
	import type { Device } from 'src/types/Device';

	export let device: Device;

	let confirmModal: IrrigationConfirmModal;
</script>

<Alert
	class="mb-s"
	heading={$format('xt1_alert_base_temp', {
		default: 'Watering time is adjusted by 10% for each °C above or below the base temperature.',
	})}
/>
<TemplateInputSettings
	{device}
	setting="base_temp"
	min={5}
	max={50}
	unit="°C"
	icon="far fa-thermometer-three-quarters"
	{confirmModal}
/>

{#if isSequenceRunning(device)}
	<IrrigationConfirmModal bind:this={confirmModal} />
{/if}
